import { StrictMode } from "react";
import ReactDOM from "react-dom";
import { registerEntryFilesForReload } from "@p81-common/shell-core-js";
import { unregister } from "./registerServiceWorker";
import App from "App";

// Module Federation entry files. A deploy replaces every content-hashed chunk
// and deletes the old ones, and these entry files are served with no
// Cache-Control — so a tab that has one cached keeps asking for chunk names
// that no longer exist. Reloading alone does not fix that: a normal reload
// does not revalidate subresources, so it replays the same stale entry file.
// Registering them here lets the recovery in shell-core-js refresh the right
// one before it reloads. Same base URLs the MF remotes are built from (see
// cracoConfig/craco.config.js).
registerEntryFilesForReload([
  ...[
    process.env.REACT_APP_NETWORK_REMOTE_URL,
    process.env.REACT_APP_INTERNET_ACCESS_REMOTE_URL,
    process.env.REACT_APP_NETWORKING_GLOBAL_CP_REMOTE_URL,
  ]
    .filter(Boolean)
    .map((base) => `${base}/remoteEntry.js`),
  // The host exposes its own container to the MFEs, and it is unhashed too.
  "/remoteEntry.js",
]);

// fixes https://github.com/webpack-contrib/extract-text-webpack-plugin/issues/456

// require('style-loader/lib/addStyles');
// require('css-loader/lib/css-base');

ReactDOM.render(
  <StrictMode>
    <App />
  </StrictMode>,
  document.getElementById("root")
);

unregister();
